import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'account-orders-details-items-extra-fields',
    templateUrl: './account.orders.details.items.extra-fields.component.html',
    styleUrls: ['./../../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountOrdersDetailsItemsExtraFieldsComponent {
    @Input('item') item;

    /**
     * Item extra fields length is greater than zero.
     **/
    public hasExtraFields(item): boolean {
        return Object.keys(item.extra_fields).length > 0 || Object.keys(item.item.extra_fields).length > 0;
    }
    /**
     * Get extra fields and values from item's extra fields.
     **/
    public getExtraFields(item) {
        if(Object.keys(item.extra_fields).length == 0){
            return Object
                .keys(item.item.extra_fields)
                .map(slug => item.item.extra_fields[slug]);
        }

        return Object
            .keys(item.extra_fields)
            .map(slug => item.extra_fields[slug]);
    }
    /**
     * Get extra fields and values from item's extra fields.
     **/
    public getExtraFieldValues(extraField) {
        const values = extraField.values || {};
        return Object.keys(values).map(key => values[key]);
    }
    /**
     * Get extra fields and values from item's extra fields.
     **/
    public getEntityReferenceKeys(entityReference) {
        return Object.keys(entityReference);
    }
    /**
     * Return if field is not identification field (id or real_id).
     **/
    public isId(slug: string) {
        return slug === 'id'
            || slug === 'real_id';
    }
    /**
     * Assert if extra field value is an object.
     **/
    public isEntityReference(extraFieldValue: any) {
        return typeof extraFieldValue === 'object';
    }
    /**
     * Assert if extra field value object has source keys.
     **/
    public isFile(extraFieldValue) {
        return extraFieldValue !== null
            && extraFieldValue.source !== undefined
            && extraFieldValue.filename !== undefined
            && extraFieldValue.temporary_public_source !== undefined;
    }
    /**
     * Assert if extra field value object has an option value keys.
     **/
    public isOption(extraFieldValue) {
        return extraFieldValue !== null
            && extraFieldValue.id !== undefined
            && extraFieldValue.key !== undefined
            && extraFieldValue.label !== undefined
            && extraFieldValue.order !== undefined;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/account/orders/details/items/extra-fields/account.orders.details.items.extra-fields.component.ts